import { EventName } from "module/analytics/types"

import { BoxProps, HStack, SliderFilledTrack, SliderThumb, SliderTrack, useColorModeValue } from "@chakra-ui/react"
import { PerpSlider } from "component/PerpSlider"

const BuyingPowerSliderConfigs = {
    STEP: 0.05,
    MIN: 0,
    MAX: 1,
}

interface BuyingPowerSliderProps extends BoxProps {
    isShort: boolean
    isDisabled?: boolean
    value: number
    isCompact?: boolean
    onFocus?: () => void
    onSlideChange: (value: number) => void
}

export function BuyingPowerSlider({
    onFocus,
    onSlideChange,
    isCompact,
    value,
    isShort,
    isDisabled,
    ...stackProps
}: BuyingPowerSliderProps) {
    const profitColor = useColorModeValue("green.500", "green.300")
    const lossColor = useColorModeValue("red.500", "red.400")

    // TODO: max button logic
    if (isCompact) {
        return (
            <HStack spacing={3} h="24px" {...stackProps}>
                <PerpSlider
                    isDisabled={isDisabled}
                    onFocus={onFocus}
                    onChange={onSlideChange}
                    aria-label="slider-ex-1"
                    value={value}
                    focusThumbOnChange={false}
                    min={BuyingPowerSliderConfigs.MIN}
                    max={BuyingPowerSliderConfigs.MAX}
                    step={BuyingPowerSliderConfigs.STEP}
                    role="group"
                    trackingProps={{
                        eventName: EventName.POSITION_OPEN_BUYING_POWER_CHANGE,
                        payload: { percentOfBP: value },
                    }}
                >
                    <SliderTrack bg={isShort ? "red.900" : "green.900"}>
                        <SliderFilledTrack bg={isShort ? "red.400" : "green.400"} />
                    </SliderTrack>
                    <SliderThumb
                        _groupHover={{ opacity: { lg: 1 } }}
                        opacity={{ lg: 0 }}
                        bg={isShort ? lossColor : profitColor}
                    />
                </PerpSlider>
            </HStack>
        )
    } else {
        return (
            <HStack spacing={5} h="34px" {...stackProps}>
                <PerpSlider
                    isDisabled={isDisabled}
                    onFocus={onFocus}
                    onChange={onSlideChange}
                    aria-label="slider-ex-1"
                    value={value}
                    focusThumbOnChange={false}
                    min={BuyingPowerSliderConfigs.MIN}
                    max={BuyingPowerSliderConfigs.MAX}
                    step={BuyingPowerSliderConfigs.STEP}
                    trackingProps={{
                        eventName: EventName.POSITION_OPEN_BUYING_POWER_CHANGE,
                        payload: { percentOfBP: value },
                    }}
                >
                    <SliderTrack bg={isShort ? "red.900" : "green.900"}>
                        <SliderFilledTrack bg={isShort ? "red.400" : "green.400"} />
                    </SliderTrack>
                    <SliderThumb bg={isShort ? lossColor : profitColor} />
                </PerpSlider>
                {/* <Badge>Max</Badge> */}
            </HStack>
        )
    }
}
